import { render, staticRenderFns } from "./listqueens.vue?vue&type=template&id=7eebd6d4&"
import script from "./listqueens.vue?vue&type=script&lang=js&"
export * from "./listqueens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports